export const REDUCER_NAME='facebookAccountSlice'

export interface iFacebookAccountDTO {
    // vendorId: string;
    fbuserId: string;
    fbpageId: string;
    fbAccountId: string;
    fbbusinessId: string;
    tokenExpiresAt: Date;
    status?: string;
    accessToken?: string;
}

export interface iFacebookAccountState {
    isLoading: boolean; 
    facebookAccountList: iFacebookAccountDTO[]; 
    errorMessage: string | null; 
  }
  